import 'core-js/modules/es.object.assign.js';
import { __awaiter } from '../../../_virtual/_tslib.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { Modal, Stack, Text, Button, Snackbar } from '@hub-la/design-system';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { useFormik, FormikProvider } from 'formik';
import { useTranslation } from 'react-i18next';
import { AccountVerificationHeader } from '../components/account-verification-header.js';
import { BillingAddressForm } from '../components/billing-address-form.js';
import { PersonForm } from '../components/person-form.js';
import { WithdrawalForm } from '../components/withdrawal-form.js';
import { useSubmitAccountVerification } from '../hooks/use-submit-account-verification.js';
import { makeInitialValues } from '../validation/initial-values.js';
import { makeValidationSchema } from '../validation/validation-schema.js';

const AccountVerificationModal = props => {
  var _a;
  const {
    open,
    onClose,
    onFinish
  } = props;
  const {
    t
  } = useTranslation();
  const {
    mutateAsync: submitAccountVerification,
    isLoading,
    error,
    reset,
    isSuccess
  } = useSubmitAccountVerification();
  const formik = useFormik({
    validationSchema: makeValidationSchema(),
    validateOnMount: true,
    validateOnChange: true,
    enableReinitialize: true,
    initialValues: makeInitialValues(),
    onSubmit: values => __awaiter(void 0, void 0, void 0, function* () {
      submitAccountVerification(values).then(() => {
        onFinish === null || onFinish === void 0 ? void 0 : onFinish();
      });
    })
  });
  return jsxs(Fragment, {
    children: [jsx(Modal, Object.assign({
      size: "full",
      open: open,
      onClose: onClose
    }, {
      children: jsx(FormikProvider, Object.assign({
        value: formik
      }, {
        children: jsxs(Stack, Object.assign({
          direction: "column",
          spacing: 6
        }, {
          children: [jsxs(Stack, Object.assign({
            direction: "row",
            onClick: onClose,
            alignSelf: "end",
            style: {
              cursor: 'pointer'
            }
          }, {
            children: [jsx(Text, Object.assign({
              variant: "body1"
            }, {
              children: t('accountVerification.form.close')
            })), jsx(CloseOutlinedIcon, {})]
          })), jsx(AccountVerificationHeader, {}), jsx(PersonForm, {}), jsx(BillingAddressForm, {}), jsx(WithdrawalForm, {}), jsx(Stack, Object.assign({
            alignSelf: "end"
          }, {
            children: jsx(Button, Object.assign({
              variant: "filled",
              disabled: !formik.isValid,
              loading: isLoading,
              onClick: () => formik.submitForm()
            }, {
              children: t('accountVerification.form.submit')
            }))
          }))]
        }))
      }))
    })), jsx(Snackbar, Object.assign({
      open: !!error,
      variant: "negative",
      onClose: () => reset(),
      autoHideDuration: null
    }, {
      children: (_a = t(error === null || error === void 0 ? void 0 : error.message)) !== null && _a !== void 0 ? _a : ''
    })), jsx(Snackbar, Object.assign({
      open: isSuccess,
      variant: "positive",
      closeable: false,
      onClose: () => reset()
    }, {
      children: t('success')
    }))]
  });
};

export { AccountVerificationModal };
